/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AdminApiKeyFromJSON, AdminMemberFromJSON, RoleDetailFromJSON, SystemStatusFromJSON, } from '../models/index';
/**
 *
 */
export class AdminApi extends runtime.BaseAPI {
    /**
     * Get System Status
     */
    getSystemStatusApiV1AdminSystemGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/admin/system`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SystemStatusFromJSON(jsonValue));
        });
    }
    /**
     * Get System Status
     */
    getSystemStatusApiV1AdminSystemGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSystemStatusApiV1AdminSystemGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Api Keys
     */
    listApiKeysApiV1AdminApiKeysGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/admin/api-keys`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminApiKeyFromJSON));
        });
    }
    /**
     * List Api Keys
     */
    listApiKeysApiV1AdminApiKeysGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listApiKeysApiV1AdminApiKeysGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Members
     */
    listMembersApiV1AdminMembersGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/admin/members`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminMemberFromJSON));
        });
    }
    /**
     * List Members
     */
    listMembersApiV1AdminMembersGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listMembersApiV1AdminMembersGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List Role Details
     */
    listRoleDetailsApiV1AdminRolesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/admin/roles`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleDetailFromJSON));
        });
    }
    /**
     * List Role Details
     */
    listRoleDetailsApiV1AdminRolesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listRoleDetailsApiV1AdminRolesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Revoke Api Key
     */
    revokeApiKeyApiV1AdminApiKeysKeyHashDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['keyHash'] == null) {
                throw new runtime.RequiredError('keyHash', 'Required parameter "keyHash" was null or undefined when calling revokeApiKeyApiV1AdminApiKeysKeyHashDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/admin/api-keys/{key_hash}`.replace(`{${"key_hash"}}`, encodeURIComponent(String(requestParameters['keyHash']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Revoke Api Key
     */
    revokeApiKeyApiV1AdminApiKeysKeyHashDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.revokeApiKeyApiV1AdminApiKeysKeyHashDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Send Test Email
     */
    sendTestEmailApiV1AdminNotificationsTestEmailPostRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/admin/notifications/test-email`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Send Test Email
     */
    sendTestEmailApiV1AdminNotificationsTestEmailPost(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendTestEmailApiV1AdminNotificationsTestEmailPostRaw(initOverrides);
        });
    }
}
